export default __webpack_public_path__ + "static/media/Critical Rating Boost (4h).c035461c.jpg";